import { Datagrid, ListProps, ReferenceField, TextField } from 'react-admin';
import { CustomList, MediaField, SortableDatagridBody } from '../../components';
import ActiveField from '../../components/ActiveField';

export default function ProductssList(props: ListProps) {
  return (
    <CustomList
      {...props}
      filter={{
        $limit: -1,
        $sort: 'position',
        $select: 'image name active brand',
        $populate: [
          {
            path: 'brand',
            select: 'name'
          }
        ]
      }}
      pagination={false}
    >
      <Datagrid body={<SortableDatagridBody filterColumn="brand" />} rowClick="edit">
        <MediaField label="Foto" source="image" sortable={false} />

        <TextField label="Nome" source="name" sortable={false} />

        <TextField label="Marca" source="brand.name" sortable={false} />
        
        <ActiveField label="Ativo" />
      </Datagrid>
    </CustomList>
  );
}
